export default __webpack_public_path__ + "static/media/SeaLife_00.b99e6187.png";